export enum AppEventTypes {
    FARM_GET = 'farm_get',
    SELECTED_FARM = 'selected_farm',
    FARM_SOIL_UPDATED='farm_soil_updated'
}